import React, { useState, useEffect } from "react"; // Added useState and useEffect here
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from "react-router-dom"; // Added useNavigate
import { onAuthStateChanged } from "firebase/auth"; // Ensure this is imported
import { database, auth } from "./firebaseConfig"; // Ensure this is imported
import { ref, get } from "firebase/database";
import { AuthProvider } from "./AuthContext";
import LandingPage from "./LandingPage";
import ChatPageNew from "./ChatPageNew";
import PaymentPage from "./PaymentPage";
import LoadingScreen from "./LoadingScreen";
import AboutPage from './AboutPage';
import ContactPage from './ContactPage';
import HelpPage from './HelpPage';
import Settings from './Settings';
import ProfilePage from './ProfilePage';
import SignIn from './SignIn';
import SignUp from './SignUp';
import NotFound from './NotFound';
import Offline from './Offline';
import DashboardLayout from './DashboardLayout';

function AppContent() {
  const [user, setUser] = useState(null);
  const [loadingState, setLoadingState] = useState(true);
  const navigate = useNavigate();

  // --- ADD THIS SECTION TO FIX THE ERROR ---
  const [userData, setUserData] = useState({
    plan: "FREE",
    dailyUsage: 0,
    searchFallback: true
  });

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      setUser(currentUser);
      
      if (currentUser) {
        // Fetch the user data from Database once we have a user
        try {
          const userRef = ref(database, `users/${currentUser.uid}`);
// Inside your onAuthStateChanged logic in App.js
const snapshot = await get(userRef);
if (snapshot.exists()) {
  const data = snapshot.val();
  
  // Get today's date string (make sure this matches your DB key format)
  const todayStr = new Date().toDateString(); 
  
  // Look for the specific value, or default to 0
  const minutesToday = data.dailyUsage?.[todayStr]?.minutes || 0;

  setUserData({
    plan: data.settings?.plan || "FREE",
    dailyUsage: minutesToday, // Store the NUMBER, not the object
    searchFallback: data.settings?.searchFallback ?? true
  });
}
        } catch (err) {
          console.error("Error fetching user data:", err);
        }
      }
      setLoadingState(false);
    });

    return () => unsubscribe();
  }, []);  // Handle Initial Loading
  if (loadingState) {
    return <LoadingScreen />; 
  }

  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/" element={<LandingPage />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/help" element={<HelpPage />} />
      <Route path="/offline" element={<Offline />} />

      {/* Auth Routes */}
      <Route 
        path="/login" 
        element={!user ? <SignIn /> : <Navigate to="/chat" replace />} 
      />
      <Route 
        path="/signup" 
        element={!user ? <SignUp /> : <Navigate to="/chat" replace />} 
      />

{/* Protected Routes */}
<Route 
  path="/settings" 
  element={
    user ? (
      <DashboardLayout>
        {/* FIXED: Added userData={userData} prop here */}
        <Settings user={user} userData={userData} />
      </DashboardLayout>
    ) : <Navigate to="/login" />
  } 
/>
<Route 
  path="/profile" 
  element={
    user ? (
      <DashboardLayout>
        {/* FIXED: Added userData={userData} prop here */}
        <ProfilePage user={user} userData={userData} />
      </DashboardLayout>
    ) : <Navigate to="/login" />
  } 
/>
<Route 
  path="/payment" 
  element={
    user ? (
      <DashboardLayout>
        <PaymentPage userData={userData} onUpgrade={() => navigate('/upgrade')} />
      </DashboardLayout>
    ) : <Navigate to="/login" />
  } 
/>

{/* Recommended: Pass userData to Chat too so it knows the plan/preferences */}
<Route 
  path="/chat" 
  element={user ? <ChatPageNew user={user} userData={userData} /> : <Navigate to="/login" replace />} 
/>
<Route
  path="/chat/:chatId"
  element={user ? <ChatPageNew user={user} /> : <Navigate to="/login" replace />}
/>
      {/* 404 Catch-all */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppContent />
      </Router>
    </AuthProvider>
  );
}

export default App;